var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup2310(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2310"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2301"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2328"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 2320",
    d: "M1.96299e-05 50C2.2044e-05 22.3858 22.3858 8.47354e-06 50 1.08877e-05C77.6142 1.33018e-05 100 22.3858 100 50C100 77.6142 77.6142 100 50 100C22.3858 100 1.72158e-05 77.6142 1.96299e-05 50ZM83 50C83 31.7746 68.2254 17 50 17C31.7746 17 17 31.7746 17 50C17 68.2254 31.7746 83 50 83C68.2254 83 83 68.2254 83 50Z",
    fill: "#F8F9FA"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2310);
export default __webpack_public_path__ + "static/media/Group 2310.ed6e3727f624001882c1f781f826e338.svg";
export { ForwardRef as ReactComponent };